import { checkDeleted, nameDescriptor } from 'pages/AutomationEngine/helpers';

import { AUTOMATION_STEPS } from 'pages/AutomationEngine/steps';

const forApi = (orgDetails) => {
  const { message, ...others } = orgDetails;

  const stepGoal = {
    ...others,
    triggers: [
      {
        type: AUTOMATION_STEPS.email_link_clicked.type,
        triggerEmailLinkClicked: {
          message: {
            id: message.id,
          },
        },
      },
    ],
  };

  delete orgDetails.type;

  return {
    stepGoal,
    details: orgDetails,
  };
};

const forFlow = (firstTrigger, addErrorMessage, messageDictionary) => {
  const { message } = firstTrigger.triggerEmailLinkClicked || {
    message: { id: null, label: null },
  };

  const type = AUTOMATION_STEPS.email_link_clicked_goal.type;

  if (!firstTrigger.triggerEmailLinkClicked) {
    // missingtrigger, after import
    addErrorMessage(messageDictionary.automationFailedToLoad);
  } else {
    checkDeleted(messageDictionary, addErrorMessage, message, nameDescriptor);
  }
  return { message, type };
};

export const emailLinkClickedDTO = {
  forApi,
  forFlow,
};
